<template>
  <div class="sf-misc-page sf-misc-page-wide">
    <div class="sf-misc-glow-a" />
    <div class="sf-misc-glow-b" />

    <div class="sf-misc-container sf-misc-container-wide">
      <b-link class="sf-misc-logo">
        <b-img
          :src="empresaLogo"
          alt="logo"
        />
      </b-link>

      <div class="sf-misc-head">
        <h2 class="sf-misc-title">
          Under Maintenance
        </h2>
        <p class="sf-misc-text">
          Sorry for the inconvenience but we're performing some maintenance at the moment
        </p>
      </div>

      <div class="sf-misc-chart-card">
        <div class="sf-misc-chart-head">
          <div>
            <div class="sf-misc-chart-title">
              Line Chart
            </div>
            <div class="sf-misc-chart-subtitle">
              Commercial networks
            </div>
          </div>
          <div class="sf-misc-datepicker">
            <feather-icon
              icon="CalendarIcon"
              size="16"
            />
            <flat-pickr
              v-model="rangePicker"
              :config="{ mode: 'range'}"
              class="form-control flat-picker bg-transparent border-0 shadow-none"
              placeholder="YYYY-MM-DD"
            />
          </div>
        </div>

        <vue-apex-charts
          type="area"
          height="400"
          :options="apexChatData.lineAreaChartSpline.chartOptions"
          :series="apexChatData.lineAreaChartSpline.series"
        />
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { BLink, BImg } from 'bootstrap-vue'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import VueApexCharts from 'vue-apexcharts'
import flatPickr from 'vue-flatpickr-component'
import apexChatData from './apexChartData'
import performanceStoreModule from './performanceStoreModule'

const PERFORMANCE_STORE_MODULE_NAME = 'publico-performance'

export default {
  components: {
    BLink,
    BImg,
    VueApexCharts,
    flatPickr,
  },
  data() {
    return {
      loadingOverlay: false,
      apexChatData,
      rangePicker: ['2019-05-01', '2019-05-10'],
    }
  },

  created() {
    if (!store.hasModule(PERFORMANCE_STORE_MODULE_NAME)) store.registerModule(PERFORMANCE_STORE_MODULE_NAME, performanceStoreModule)
  },

  beforeDestroy() {
    if (store.hasModule(PERFORMANCE_STORE_MODULE_NAME)) store.unregisterModule(PERFORMANCE_STORE_MODULE_NAME)
  },

  setup() {
    const { empresa, empresaLogo } = useAppConfig()
    const { appName } = $themeConfig.app

    return {
      empresa,
      empresaLogo,
      appName,
    }
  },

  methods: {

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>

<style lang="scss" scoped>
/* ============================================================
   Páginas "misc" (404 / não autorizado / manutenção) — Soulf.
   ============================================================ */
.sf-misc-page {
  min-height: 100vh;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  position: relative;
  overflow: hidden;
  font-family: 'Geist', sans-serif;
}
.sf-misc-glow-a {
  position: absolute; width: 520px; height: 520px; border-radius: 50%;
  background: rgba(37, 99, 235, 0.08); filter: blur(90px);
  top: -160px; right: -120px; pointer-events: none;
}
.sf-misc-glow-b {
  position: absolute; width: 420px; height: 420px; border-radius: 50%;
  background: rgba(37, 99, 235, 0.06); filter: blur(90px);
  bottom: -140px; left: -100px; pointer-events: none;
}
.sf-misc-container { width: 100%; max-width: 460px; position: relative; z-index: 1; }

.sf-misc-logo {
  display: flex; align-items: center; justify-content: center; gap: 10px;
  margin-bottom: 24px; text-decoration: none;
  &.hidden { display: none !important; }
}
.sf-misc-brand { font-size: 17px; font-weight: 600; color: #fff !important; margin: 0; }

.sf-misc-card {
  background: #0F0F11;
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 20px;
  padding: 40px 34px;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute; top: 0; left: 0; right: 0; height: 1px;
    background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.5), transparent);
  }
}
.sf-misc-illustration { max-width: 220px; width: 100%; margin: 0 auto 24px; }
.sf-misc-title { font-size: 20px; font-weight: 600; color: #fff; margin: 0 0 8px; }
.sf-misc-text { font-size: 13.5px; color: rgba(255, 255, 255, 0.55); line-height: 1.5; margin: 0 0 24px; }
.sf-misc-btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  border: none; background: #3b82f6; color: #fff !important;
  font-family: 'Geist', sans-serif; font-weight: 600; font-size: 13.5px;
  padding: 11px 26px; border-radius: 9999px; cursor: pointer;
  box-shadow: 0 0 32px rgba(59, 130, 246, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.15);
  transition: transform .15s ease;
  text-decoration: none;

  &:hover { transform: translateY(-2px); color: #fff !important; text-decoration: none; }
}
</style>

<style lang="scss" scoped>
.sf-misc-page-wide { align-items: flex-start; padding-top: 60px; }
.sf-misc-container-wide { max-width: 760px; }
.sf-misc-head { text-align: center; margin-bottom: 24px; }

.sf-misc-chart-card {
  background: #0F0F11;
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 16px;
  padding: 20px;
}
.sf-misc-chart-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.sf-misc-chart-title { font-size: 15px; font-weight: 600; color: #fff; }
.sf-misc-chart-subtitle { font-size: 12.5px; color: rgba(255, 255, 255, 0.45); margin-top: 2px; }
.sf-misc-datepicker {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.55);

  ::v-deep .form-control {
    background: transparent !important;
    border: none !important;
    color: #fff !important;
    box-shadow: none !important;
    padding: 0 !important;
    width: 130px;
  }
}
</style>
